// Material UI
import { makeStyles } from '@material-ui/core';
import { neutral } from '../../shared/styles/colors';

export default makeStyles(theme => ({
  body: {
    height: '100%',
    paddingTop: 24,
    padding: '16px',
    [theme.breakpoints.up('md')]: {
      padding: '24px',
      paddingBottom: '40px',
    },
  },
  text: {
    paddingBottom: '30px',
    fontFamily: 'Poppins',
    fontSize: '17px',
    letterSpacing: 0,
    fontWeight: 'normal',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 'normal',
    color: neutral.D20,
  },
  noteText: {
    marginTop: '30px',
    fontSize: '13px',
    fontWeight: 'normal',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 'normal',
    letterSpacing: 'normal',
    color: neutral.D15,
  },
  headerRoot: {
    [theme.breakpoints.up('md')]: {
      padding: 12,
    },
  },
  paper: {
    [theme.breakpoints.up('md')]: {
      height: 456,
      width: 557,
      overflowY: 'hidden',
    },
  },
  box: {
    marginBottom: 10,
  },
}));
